import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { AuthService } from './services/auth/auth.service';
import { PBService } from './services/pocketbase.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SidenavComponent, CommonModule],
  templateUrl: './app.component.html',
})
export class AppComponent {
  private authService = inject(AuthService);
  public pbService = inject(PBService);
  private translate = inject(TranslateService);

  constructor() {
    this.translate.onLangChange.subscribe((event) => {
      if (typeof document !== 'undefined') {
        document.documentElement.lang = event.lang;
      }
    });

    if (typeof document !== 'undefined' && this.translate.currentLang) {
      document.documentElement.lang = this.translate.currentLang;
    }
  }

  get isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }
}
